import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/dev_tools_300.png'


const _withScopeId = n => (_pushScopeId("data-v-19d6f9aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dev-landing-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "user-type" }, "For developers", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Developer tools",
  class: "page-icon"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Use our API to build new experiences", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-text" }, " The Tree Crossing API provides a secure, consistent way for authorized clients to access private family tree data regardless of the original database format. Data access is controlled by the data owner. API access is granted to select partners who want to build new experiences that encourage families to find and learn more about their ancestors together. ", -1))

import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeveloperLandingPage',
  setup(__props) {

const router = useRouter()

function requestAccess() {
  router.push({ path: '/contact', query: { subject: 'Request API access'} })
}  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "page-content container-lg" }, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        onClick: requestAccess
      }, " Request access to API ")
    ])
  ]))
}
}

})